<template>
  <div class="chatbot_wrap">
    <div class="chatbot_icon" @click="openChatBox">
      <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
        <rect width="36.7813" height="30.888" rx="7" fill="#F3F3F3"/>
        <path
            d="M6.13281 30.2148H17.627L8.66437 37.9172C8.35971 38.179 7.9713 38.323 7.56958 38.323V38.323V38.323C6.76096 38.2686 6.13281 37.5969 6.13281 36.7864V30.2148Z"
            fill="#F3F3F3"/>
        <ellipse cx="9.05254" cy="16.1069" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
        <ellipse cx="18.1463" cy="16.2046" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
        <ellipse cx="27.2478" cy="16.1069" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
        <path
            d="M42.1875 43.1406H33.5938L40.3 49.106C40.524 49.3053 40.8134 49.4154 41.1133 49.4154V49.4154V49.4154C41.7182 49.3733 42.1875 48.8703 42.1875 48.2639V43.1406Z"
            fill="#B0B0B0"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M17.1875 33.7299V36.142C17.1875 40.008 20.3215 43.142 24.1875 43.142H41.4373C45.3032 43.142 48.4373 40.008 48.4373 36.142V25.043C48.4373 21.177 45.3032 18.043 41.4373 18.043H39.062V26.7299C39.062 30.5958 35.928 33.7299 32.062 33.7299H17.1875Z"
              fill="#B0B0B0"/>
      </svg>
    </div>
    <div class="chatbot_box_wrap" :class="{open: isOpenChat, 'chatbot_box_wrap_no_login': messages?.length === 0}">
      <div v-if="isCloseChat" class="closing_chatbox">
        <p>Want To Close Chat</p>
        <div class="d_flex_center">
          <button @click="closeThisChat">Close</button>
          <button class="stay" @click="closeChatAlert">Stay</button>
        </div>

        <div class="close_ic" @click="closeChatAlert">
          <i class="lni lni-close"></i>
        </div>
      </div>
      <div v-if="messages?.length === 0" class="without_login_popup">
        <h4>Want To Start Chat</h4>
        <div class="d_flex_center">
          <a class="btn btn-sm btn-primary" role="button" @click.prevent="joinChatSupport">Yes, Start</a>
        </div>
      </div>
      <div class="chatbot_box">
        <div class="js_chat_wrap" id="chat_wrap">

          <h1 class="chat_title">
            <span>Message</span>
            <span class="close_chat">
              <i class="lni lni-minus px-3" @click="minimizeChatBox"></i>
              <i class="lni lni-close" @click="openChatAlert"></i>
            </span>
          </h1>
          <div class="js_chat_head chat_head" :class="{has_upload_option: tempFile}">
            <div class="chat_head_inner" ref="scrollableDiv">
              <ul>
                <div class="comments">
                  <template v-for="(message, i) in messages" :key="'key_'+i">
                    <li :class="{reply : message.type === 'customer'}">
                      <div class="append_inner">
                        <div v-if="message.link" class="file">
                          <template v-if="getFileExtension(message.link) === 'pdf'">
                            <embed :src="message.link" width="150">
                            <div><a :href="message.link" target="_blank">Open PDF</a></div>
                          </template>
                          <img v-else @load="scrollDown" :src="message.link" alt="">
                        </div>
                        <div class="text">
                          <h2>
                            <span>{{ message.message }}</span>
                          </h2>
                          <div class="time">
                            {{ message.created_at }}
                          </div>
                          <div class="option_text" v-if="message.type === 'customer'">
                            <span  @click="removeMessage(i, message)">
                              <i class="lni lni-trash-can"></i>
                            </span>
                            <span :class="[{'checked text-success': message.read}, {'opacity_5':!message.read}]">
                              <i class="lni lni-checkmark"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </template>
                  <li v-if="showMainCategory && messages && messages.length === 1" class="reply product_subcat">
                    <div class="append_inner">
                      <div class="text">
                        <h2>
                          <span v-for="(category, categoryIndex) in categories" :key="'category_'+categoryIndex"
                                @click="selectCategory(category)">
                            {{ category.name }}
                          </span>
                        </h2>
                      </div>
                    </div>
                  </li>
                  <li class="reply product_subcat"
                      v-if="showSubCategory && selectedSubCategories && selectedSubCategories.length > 0">
                    <div class="append_inner">
                      <div class="text">
                        <h2>
                          <span v-for="(subCategory, subCategoryIndex) in selectedSubCategories"
                                :key="'subCategory_'+subCategoryIndex"
                                @click="selectSubCategory(subCategory)">{{ subCategory.name }}</span>
                          <span @click="returnToMainMenu()">Return to main menu</span>
                        </h2>
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </div>

          <div class="reply_form">
            <div class="reply_form_inner">
              <div class="attach_btn">
                <input
                    type="file"
                    id="upload" hidden
                    accept="image/*,application/pdf"
                   @change="onFileChange($event)"
                >
                <label for="upload"><i class="lni lni-paperclip"></i></label>
              </div>
              <textarea v-model="form.message" class="form_global" id="" cols="30" rows="10" placeholder="Type here"
                        @keyup.enter="sendMessage('customer')" @paste="handlePaste"></textarea>
              <div class="submit"
                   @click.prevent="sendMessage('customer')"
              >
                <svg width="34px" height="34px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                        d="M11.5003 12H5.41872M5.24634 12.7972L4.24158 15.7986C3.69128 17.4424 3.41613 18.2643 3.61359 18.7704C3.78506 19.21 4.15335 19.5432 4.6078 19.6701C5.13111 19.8161 5.92151 19.4604 7.50231 18.7491L17.6367 14.1886C19.1797 13.4942 19.9512 13.1471 20.1896 12.6648C20.3968 12.2458 20.3968 11.7541 20.1896 11.3351C19.9512 10.8529 19.1797 10.5057 17.6367 9.81135L7.48483 5.24303C5.90879 4.53382 5.12078 4.17921 4.59799 4.32468C4.14397 4.45101 3.77572 4.78336 3.60365 5.22209C3.40551 5.72728 3.67772 6.54741 4.22215 8.18767L5.24829 11.2793C5.34179 11.561 5.38855 11.7019 5.407 11.8459C5.42338 11.9738 5.42321 12.1032 5.40651 12.231C5.38768 12.375 5.34057 12.5157 5.24634 12.7972Z"
                        stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </g>
                </svg>
              </div>
            </div>
            <div v-if="tempFile" class="file_upload">
              <div class="file_img">
                <div class="img">
                  <svg v-if="fileType === 'application/pdf'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                  <img v-else :src="tempFile" alt="">
                </div>
                <div class="file_info">
                  <p>{{ fileName }}</p>
                  <p class="file_size">{{ fileSize }}</p>
                </div>

              </div>
              <div class="close_file_ic pointer" @click="removeImage()">
                <i class="lni lni-close"></i>
              </div>
            </div>

            <!-- <div class="start_over">
                <p>chat Ended</p>
                <button>Start</button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Howl} from "howler";
import {mapGetters} from "vuex";
import {io} from "socket.io-client";
import dayjs from "dayjs";
import {v4 as uuidv4} from 'uuid';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
  name: "ChatBox",
  data() {
    return {
      isOpenChat: false,
      socketUrl: process.env.VUE_APP_SOCKET_URL,
      socket: null,
      chats: [],
      messages: [],
      tabIsActive: false,
      form: {
        message: '',
        customer_id: null,
        category_id: null,
        sub_category_id: null,
        link: '',
        type: '',
      },
      tempFile: '',
      fileSize: '',
      fileName: '',
      fileType: '',
      interval: null,
      incomingMessageSound: new Howl({
        src: ['/audio.mp3'],
        volume: 1.0,
      }),
      isCloseChat: false,
      showMainCategory: true,
      showSubCategory: true,
      categories: [],
      selectedSubCategories: [],
      chatSettings: null,
      activeChatId: null
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
    }),
    lastMessage() {
      if (this.messages?.length) {
        return this.messages.filter(item => item.type === 'admin').pop();
      }
      return null;
    }
  },
  watch: {
    tabIsActive:{
      handler: function() {
        this.makeReadMessages()
      },
      deep: true
    }
  },
  mounted() {
    this.getChatSettings();
    this.getActiveCategories();
    this.initSocket()
    this.checkTabStatus();
    this.interval = setInterval(this.updateTime, 60 * 1000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    getFileExtension(url){
      return url.split('.').pop().toLowerCase();
    },
    checkTabStatus() {
      this.tabIsActive = !document.hidden;
    },
    sendMessage(type) {
      if (this.form.message || this.form.link) {
        this.form.customer_id = this.customer?.ticket_customer_id
        this.form.type = type

        this.form.session_id = this.customer?.session_id
        let formData = new FormData()
        Object.entries(this.form).forEach(([key, file]) => {
          formData.append(key, file);
        });

        this.removeImage()
        this.form.message = ''
        this.axios.post('/chat/send-message', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        })
            .then(({data}) => {
              if (data.success){
                let index = this.messages.push({
                  'id': '',
                  'type': type,
                  'customer_id': this.customer?.ticket_customer_id,
                  'created_at': 'Just Now',
                  'read': 0,
                  'message': data.data.data.message
                })
                setTimeout(() => {
                  this.scrollDown(true)
                }, 20);

                this.messages[index - 1].id = data.data.data.id
                this.messages[index - 1].created_at = data.data.data.created_at
                this.messages[index - 1].short_by_date = data.data.data.short_by_date
                this.messages[index - 1].link = data.data.data.link
                this.messages[index-1].api_token = data.data.data.customer.api_token
                this.socket.emit('customerMessage', data.data.data);
                this.updateTime()
                setTimeout(() => {
                  this.scrollDown(true)
                  this.removeImage()
                }, 20);
              } else {
                this.showFailMsg(data?.error?.errors?.link[0]);
              }
            })
            .catch(() => {
            })
            .finally(() => {
              if (this.messages.length > 1) {
                this.showMainCategory = false
                this.showSubCategory = false
              }
            })
      }
    },
    joinChatSupport() {
      this.axios.post('/join-chat-support', {
        session_id: uuidv4()
      }).then(({data}) => {
        if (data.success) {
          // Handle success response
          this.$store.dispatch("auth/customerInfo", data.data)
          // $toast.success(response.data.message);
          if (this.chatSettings && this.messages && this.messages.length < 1) {
            this.form.message = this.chatSettings.greeting_message
            this.sendMessage('admin')
            this.socket.emit('newCustomerJoinMessage');
          }
        } else {
          // Handle failure response
          // $toast.error(response.data.message);
        }
      });
    },
    initSocket() {
      if (this.customer) {
        this.getMessage();
        this.socket = io(this.socketUrl + '/chat-support');

        // Join as a customer
        this.socket.emit('customerJoin', {customerId: this.customer?.ticket_customer_id});

        // Listen for messages from admin
        this.socket.on("customerMessage", (data) => {
          if (data.event_type === 'delete') {
            this.deleteEventMessage(data);
          } else if (data.event_type === 'read') {
            this.readStatusChange(data);
          } else if (data.type === 'admin') {
            this.playIncomingMessageSound();
            this.messages.push({...data});
            setTimeout(() => {
              this.scrollDown(true);
              this.makeReadMessages();
            }, 100);
          }
        });

        // Listen for messages from other customer tabs/devices
        this.socket.on("ownCustomerMessage", (data) => {
          if (!this.messages.some(msg => msg.id === data.id)) {
            this.messages.push({...data});
            setTimeout(() => {
              this.scrollDown(true);
              this.makeReadMessages();
            }, 100);
          }
        });
      }
    },

    getMessage() {
      this.axios.get('/chat/get-current-chats', {
        params:
            {customer_id: this.customer?.id}
      })
          .then(({data}) => {
            this.activeChatId = data?.data?.data?.id
            this.messages = data?.data?.data?.messages ?? []
            setTimeout(() => {
              this.updateTime()
              this.scrollDown()
              this.makeReadMessages()
            }, 50);
          })
    },
    updateTime() {
      if (this.messages && this.messages?.length) {
        const currentTime = dayjs();
        this.messages.map((item) => {
          const someDate = dayjs(item.short_by_date);
          item.created_at = someDate?.from(currentTime);
        })
      }
    },
    scrollDown(behavior = true) {
      const lastChildElement = this.$refs.scrollableDiv;
      let lastLi = lastChildElement?.querySelector('li:last-child');
      if (behavior) {
        lastLi?.scrollIntoView({
          behavior: 'smooth',
        });
      } else {
        lastChildElement?.scrollIntoView();
      }
    },
    makeReadMessages() {
      if (this.customer && this.tabIsActive) {
        this.axios.get('/chat/message-unread?customer_id=' + this.customer?.id + "&type=admin")
            .then((response) => {
              this.socket.emit('customerMessage', response.data);
            })
      }
    },
    removeMessage(i, message) {
      this.axios.get('/chat/delete-message?id=' + message.id + '&type=customer')
          .then((response) => {
            this.socket.emit('customerMessage', response.data);
            this.messages.splice(i, 1);
          })
    },
    deleteEventMessage(event) {
      let index = this.messages.findIndex((item) => item.id === parseInt(event.id))
      this.messages.splice(index, 1);
    },
    readStatusChange() {
      this.messages.map((item) => item.read = 1)
    },
    removeImage() {
      this.tempFile = ''
      this.fileSize = ''
      this.fileName = ''
      this.fileType = ''
      this.form.link = ''
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;
      let file = event.target.files[0]
      this.form.link = file
      this.fileName = file.name
      this.fileType = file.type
      this.generateFileSize(file.size)
      this.tempFile = URL.createObjectURL(file)
    },
    generateFileSize(size) {
      if ((size / (1024 * 1024)) >= 1) {
        this.fileSize = (size / (1024 * 1024)).toFixed(2) + ' MB';
      } else {
        this.fileSize = (size / 1024).toFixed(2) + ' KB';
      }
    },
    handlePaste(event) {
      const items = event.clipboardData.items;
      for (let item of items) {
        if (item.type.startsWith("image/")) {
          const file = item.getAsFile();

          if (file) {
            this.form.link = file;                  // Assign the file directly
            this.fileName = file.name;              // Get the file name
            this.fileType = file.type;              // Get the file name
            this.generateFileSize(file.size);       // Generate the file size info
            this.tempFile = URL.createObjectURL(file); // Create a preview URL
          }
        }
      }
    },
    playIncomingMessageSound() {
      this.incomingMessageSound.play();
    },
    openFileModal() {
      this.$refs.fileInput.click();
    },
    openChatBox() {
      this.isOpenChat = !this.isOpenChat
      this.scrollDown();
      if (this.isOpenChat) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    minimizeChatBox() {
      this.isOpenChat = false
      document.body.classList.remove('no-scroll');
    },
    openChatAlert() {
      this.isCloseChat = true
      document.body.classList.add('no-scroll');
    },
    closeChatAlert() {
      this.isCloseChat = false
    },
    closeThisChat() {
      this.axios.post('/close-chat-support').then(({data}) => {
        if (data.success) {
          this.isOpenChat = false
          this.isCloseChat = false
          this.$store.dispatch("auth/customerInfo", data.data)
          this.showSuccessMsg(data.message);
          this.getMessage()
          this.socket.emit('newCustomerJoinMessage');
          document.body.classList.remove('no-scroll');
        } else {
          this.showFailMsg(data.message);
        }
      });
    },
    getActiveCategories() {
      this.axios.get('/get-active-categories').then(({data}) => {
        this.categories = data?.data?.data
      })
    },
    selectCategory(category) {
      this.form.category_id = category.id
      if (category.sub_categories && category.sub_categories.length > 0) {
        this.selectedSubCategories = category.sub_categories
        this.showMainCategory = false
        this.showSubCategory = true
      } else {
        this.form.message = category.name
        this.sendMessage('customer')
      }
    },
    selectSubCategory(category) {
      this.form.sub_category_id = category.id
      this.form.message = category.name
      this.sendMessage('customer')
    },
    returnToMainMenu() {
      this.selectedSubCategories = []
      this.showMainCategory = true
    },
    getChatSettings() {
      this.axios.get('/get-chat-settings').then(({data}) => {
        this.chatSettings = data?.data?.data
      })
    }
  }
}
</script>

<style scoped>

</style>